// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"_1LWzHY","priceLabel":"rmK_Sw","image":"_2Dhtmc","subText":"_1FfNNs","title":"_2Uyb4Q","freeMonthTitle":"_1XYstR","checkboxContainer":"_1OiNcZ","button":"_3YFVoB"};